<template>
  <div>
    <livechat-search v-model="showSearch"></livechat-search>
    <div id="livechat" v-if="$store.getters.getPackage == 'premium'">
      <div v-show="view == 'users'">
        <div id="chattype">
          <template v-if="searchlist.length == 0">
            <livechat-tab
              :newchatnotify="newchatnotify"
              @onsearch="showSearch = true"
            ></livechat-tab>
          </template>
          <template v-else>
            <livechat-search-box @onsearch="showSearch = true"></livechat-search-box>
            <v-divider></v-divider>
          </template>
        </div>

        <div
          :style="{
            'margin-top': !searchlist ? '84px' : '0',
          }"
        >
          <users
            v-model="selectedUser"
            :app="$store.state.livechat.app"
            :usersearching="usersearching"
            :filter="filter"
            :type="'admin'"
            v-if="$store.state.livechat.type == 'admin'"
            @onClickUser="onClickUser"
            :isMobile="true"
          ></users>
          <users
            v-model="selectedUser"
            :usersearching="usersearching"
            :app="$store.state.livechat.app"
            :filter="filter"
            :type="'bot'"
            v-if="$store.state.livechat.type == 'bot'"
            @onClickUser="onClickUser"
            :isMobile="true"
          ></users>
        </div>
      </div>
      <div v-if="view == 'chatbox'">
        <chatbox
          v-model="selectedUser"
          @endSession="onEndSession"
          @onClose="onCloseChatbox"
          @onShowTool="onShowTool"
          :isMobile="true"
          :key="selectedUser.userid"
        ></chatbox>

        <v-navigation-drawer v-model="showTool" right fixed temporary>
          <v-layout>
            <v-flex>
              <v-btn fab small flat class="extra-small" @click="showTool = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn
                small
                outline
                @click="endSession"
                v-if="selectedUser.context == 'contactadmin'"
                >{{ $t('Switch to bot') }}</v-btn
              >
              <v-btn
                small
                outline
                @click="openSession"
                v-else-if="selectedUser.context != 'contactadmin'"
                >{{ $t('Switch to admin') }}</v-btn
              >
            </v-flex>
          </v-layout>
          <template v-if="selectedUser">
            <livechat-chattool :selectedUser="selectedUser"></livechat-chattool>
          </template>
        </v-navigation-drawer>
      </div>
    </div>
    <div v-else style="position: relative">
      <v-premium-plan-popup
        backgroundColor="white"
        v-if="$store.getters.getPackage != 'premium'"
        style="border-radius: 10px; min-height: 100vh; height: 100%"
      ></v-premium-plan-popup>
    </div>
  </div>
</template>

<script>
import Livechat from './Livechat.js'
import LivechatCustomers from './livechat-customers'
export default {
  mixins: [Livechat],
  components: {
    LivechatCustomers,
  },
  data() {
    return {
      showTool: false,
      view: 'users',
      chattooltype: 'customer',
    }
  },
  methods: {
    onShowTool: function () {
      this.showTool = !this.showTool
    },
    onCloseChatbox: function () {
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.view = 'users'
    },
    onClickUser: function () {
      this.view = 'chatbox'
    },
    onEndSession: function () {
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.$store.dispatch('updateLivechatUser', null)
      this.$store.dispatch('forceLoadLastestUsers')
      this.showTool = false
      this.view = 'users'
    },
    onOpenSession: function () {
      this.type = 'admin'
      var user = this.$store.state.livechat.currentUser
      user.type = this.type
      this.$store.dispatch('updateLivechatUser', user)
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
      this.showTool = false
      this.view = 'users'
    },

    onResizeToolList: function () {
      var vm = this
      vm.$nextTick(function () {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatMobile.vue